// this file added by Bearer Web Developer - change map api
import { CircularProgress } from '@mui/material';
import { APIProvider, useApiIsLoaded } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';

const BearerApiMap: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const apiIsLoaded = useApiIsLoaded();
    useEffect(() => {
        // console.log('API loading status:', apiIsLoaded);
    }, [apiIsLoaded]);
    return (
        <>
            {
                apiIsLoaded ? <>{children}</> :
                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}><CircularProgress /></div>
            }
        </>
    )
};
const BearerMapProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    return (
        <APIProvider apiKey={process.env.REACT_APP_GOOGLEMAPAPI || ""} libraries={["places"]}>
            <BearerApiMap>{children}</BearerApiMap>
        </APIProvider>
)
}
export default BearerMapProvider;